import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Col, DatePicker, Form, Input, Row, Select } from 'antd';
import { getPromoStatusLabelByType } from '../../../../utilities/formatData';

const { Option } = Select;

const PromoTransactionsSearch = ({
  onSearch,
  onReset,
  form,
  initialValues,
  courseOffers,
}) => {
  const [selectedPromoType, setSelectedPromoType] = useState('');

  const isStatusOptionVisible = (status) => {
    switch (selectedPromoType) {
      case 'coupon':
        return status === 'used';
      case 'referral':
        return ['pending', 'used'].includes(status);
      case 'giftCard':
        return ['pending', 'completed', 'used', 'created'].includes(status);
      default:
        return true;
    }
  };

  const promoTypeMenu = [
    { label: 'Coupon', value: 'coupon' },
    { label: 'Gift card', value: 'giftCard' },
    { label: 'Referral', value: 'referral' },
  ].map((type, index) => (
    <Option value={type.value} key={index}>
      {type.label}
    </Option>
  ));

  const transactionStatusMenu = [
    {
      value: 'pending',
      label: getPromoStatusLabelByType(selectedPromoType, 'pending'),
      visible: isStatusOptionVisible('pending'),
    },
    {
      value: 'completed',
      label: getPromoStatusLabelByType(selectedPromoType, 'completed'),
      visible: isStatusOptionVisible('completed'),
    },
    {
      value: 'used',
      label: getPromoStatusLabelByType(selectedPromoType, 'used'),
      visible: isStatusOptionVisible('used'),
    },
    {
      value: 'created',
      label: getPromoStatusLabelByType(selectedPromoType, 'created'),
      visible: isStatusOptionVisible('created'),
    },
  ]
    .map((type, index) => {
      return type.visible ? (
        <Option value={type.value} key={index}>
          {type.label}
        </Option>
      ) : (
        false
      );
    })
    .filter((x) => !!x);

  const handlePromoTypeChange = (selectedOption) => {
    setSelectedPromoType(selectedOption);
    form.setFieldsValue({
      status: null,
    });
  };

  return (
    <div>
      <Form form={form} onFinish={onSearch} initialValues={initialValues}>
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item label="Type" name="type">
              <Select
                placeholder={'Select type'}
                onChange={handlePromoTypeChange}
              >
                {promoTypeMenu}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="Status" name="status">
              <Select placeholder={'Select status'}>
                {transactionStatusMenu}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Course Offer Applied" name="courseOffer">
              {courseOffers ? (
                <Select
                  options={courseOffers}
                  placeholder={'Select Course Offer'}
                  notFoundContent={null}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                />
              ) : null}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col>
            <Form.Item
              label="Created at"
              name="createdAt"
              rules={[{ required: false, message: 'Please input date!' }]}
            >
              <DatePicker
                showTime={true}
                showNow={false}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Search
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Reset
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Alert
        message="Promo Types and Status"
        description={
          <div>
            <ul>
              <li>
                1. Coupon
                <ul>
                  <li>Used : Coupon has been used.</li>
                </ul>
              </li>
              <li>
                2. Referral Code
                <ul>
                  <li>Pending : Coupon Applied and Purchase Made</li>
                  <li>Used : Coupon Credits added to Referral</li>
                </ul>
              </li>
              <li>
                3. Gift Card
                <ul>
                  <li>Created : Started Gift Card Purchase</li>
                  <li>
                    Payment Pending : Added Gift Card to checkout but Payment is
                    Pending
                  </li>
                  <li>
                    Payment Completed : Gift Card purchase completed and Payment
                    is Complete
                  </li>
                  <li>Used : Gift Card has been used to Purchase a Course</li>
                </ul>
              </li>
            </ul>
          </div>
        }
        type="info"
        showIcon
        closable
      />
    </div>
  );
};

PromoTransactionsSearch.propTypes = {
  onSearch: PropTypes.func,
  onReset: PropTypes.func,
  initialValues: PropTypes.object,
};

export default PromoTransactionsSearch;
